import React from "react";
import {
  Fade,
  Typography,
  Box,
  Skeleton,
  Tooltip,
  IconButton,
} from "@mui/material";
import {
  CalendarContainer,
  LegendContainer,
  LegendItem,
  LegendColor,
} from "./styles";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import koLocaleFC from "@fullcalendar/core/locales/ko";
import AssessmentIcon from "@mui/icons-material/Assessment";

function CalendarView({
  dataLoading,
  calendarRef,
  calendarEvents,
  dateRange,
  onEventClick,
  onDatesSet,
}) {
  return (
    <Fade in={!dataLoading} timeout={500}>
      <CalendarContainer>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="h6">생산계획 달력</Typography>
          <Tooltip title="상세 분석">
            <IconButton size="small">
              <AssessmentIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
        <LegendContainer>
          <LegendItem>
            <LegendColor color="#1890ff" />
            <Typography variant="body2">생산계획</Typography>
          </LegendItem>
          <LegendItem>
            <LegendColor color="#52c41a" />
            <Typography variant="body2">입고예정</Typography>
          </LegendItem>
          <LegendItem>
            <LegendColor color="#fa8c16" />
            <Typography variant="body2">출고예정</Typography>
          </LegendItem>
        </LegendContainer>
        {dataLoading ? (
          <Box sx={{ p: 2, height: "calc(100% - 80px)" }}>
            <Skeleton
              variant="rectangular"
              width="100%"
              height="100%"
              animation="wave"
            />
          </Box>
        ) : (
          <FullCalendar
            ref={calendarRef}
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            initialView="dayGridMonth"
            headerToolbar={{
              left: "prev,next today",
              center: "title",
              right: "dayGridMonth,timeGridWeek",
            }}
            events={calendarEvents}
            eventClick={onEventClick}
            datesSet={onDatesSet}
            initialDate={dateRange.start.toDate()}
            locale={koLocaleFC}
            eventTimeFormat={{
              hour: "numeric",
              minute: "2-digit",
              meridiem: false,
            }}
            height="100%"
          />
        )}
      </CalendarContainer>
    </Fade>
  );
}

export default CalendarView;
